export var en = {
  buttons: {
    save: {
      value: 'Save',
      description: ''
    },
    confirm: {
      value: 'Confirm',
      description: ''
    },
    create: {
      value: 'Create',
      description: ''
    },
    restore: {
      value: 'Restore',
      description: ''
    },
    change: {
      value: 'Change',
      description: ''
    },
    edit: {
      value: 'Edit',
      description: ''
    },
    done: {
      value: 'Done',
      description: ''
    },
    iSee: {
      value: 'I see',
      description: ''
    },
    finish: {
      value: 'Finish',
      description: ''
    },
    back: {
      value: 'Back',
      description: ''
    },
    next: {
      value: 'Next',
      description: ''
    },
    "continue": {
      value: 'Continue',
      description: ''
    },
    cancel: {
      value: 'Cancel',
      description: ''
    },
    send: {
      value: 'Send',
      description: ''
    },
    clearFilters: {
      value: 'Clear filters',
      description: ''
    },
    rent: {
      value: 'Rent',
      description: ''
    }
  },
  tableColumns: {
    name: {
      value: 'Name',
      description: ''
    },
    status: {
      value: 'Status',
      description: ''
    },
    state: {
      value: 'State',
      description: ''
    },
    dateCreation: {
      value: 'Created',
      description: ''
    },
    dateStart: {
      value: 'Start date',
      description: ''
    },
    dateEnd: {
      value: 'Start date',
      description: ''
    }
  },
  tableOptions: {
    rowsVolume: {
      value: 'Rows Volume:',
      description: ''
    }
  },
  validation: {
    required: {
      value: 'Complete this field',
      description: ''
    },
    unique: {
      value: 'This field value needs to be unique',
      description: ''
    }
  },
  textLabel: {
    creator: {
      value: 'Creator',
      description: ''
    }
  },
  serverError: {
    textTitle: {
      value: 'Server not responding',
      description: ''
    },
    text: {
      value: 'Try again later',
      description: ''
    }
  },
  dataError: {
    textTitle: {
      value: 'Failed to retrieve data',
      description: ''
    },
    text: {
      value: 'Refresh the page. Contact support if the problem persists.',
      description: ''
    }
  },
  notFound: {
    textTitle: {
      value: 'Nothing found',
      description: ''
    },
    textSearch: {
      value: 'Try changing your request',
      description: ''
    },
    textSearchFilter: {
      value: 'Try changing your query or selecting different filters',
      description: ''
    }
  },
  placeholders: {
    searchName: {
      value: 'Search by name',
      description: ''
    }
  },
  tooltip: {
    noAccess: {
      value: 'No access',
      description: ''
    }
  }
};